import { render, staticRenderFns } from "./StaffApplicationReviewDetail.vue?vue&type=template&id=1df30178&scoped=true&"
import script from "./StaffApplicationReviewDetail.vue?vue&type=script&lang=js&"
export * from "./StaffApplicationReviewDetail.vue?vue&type=script&lang=js&"
import style0 from "./StaffApplicationReviewDetail.vue?vue&type=style&index=0&id=1df30178&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df30178",
  null
  
)

export default component.exports